const request = {
    invalid_input: 'الإدخال غير صالح. {{details}}',
    general: 'حدث خطأ في الطلب.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
    /** UNTRANSLATED */
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
